export const INIT = 'app/approveEmployeeDeeds/INIT';
export const INIT_FAILED = 'app/approveEmployeeDeeds/INIT_FAILED';

export interface InitAction {
  type: typeof INIT;
}
export const initAction = () => ({
  type: INIT,
});

export const initFailedAction = (error: Error) => ({
  type: INIT_FAILED,
  error,
});
